module.exports = __webpack_public_path__ + "img/keyword.da3a5f97.svg";